@use "@/_mantine" as mantine;

.modalContent {
	margin: 0 auto;
}

.modalHeader {
	padding: var(--mantine-spacing-md) var(--mantine-spacing-xl);
	border-bottom: 1px solid var(--mantine-color-default-border);
	position: sticky;
	align-items: center;
	top: 0;
	z-index: 100;
	display: flex;
	gap: var(--mantine-spacing-md);
	background-color: var(--mantine-color-body);
	margin-bottom: var(--mantine-spacing-lg);

	&--view-ticket-modal {
		flex-direction: column;
		padding: var(--mantine-spacing-xl) var(--mantine-spacing-xl) var(--mantine-spacing-xs);
	}
}

.modalTitle {
	font-size: 1.15rem;
	font-weight: 600;
	color: var(--mantine-color-text);
	text-align: left;
	letter-spacing: -0.01em;
}

.modalBody {
	padding: 0 var(--mantine-spacing-xl) var(--mantine-spacing-lg);
}

.fixedButtons {
	position: sticky;
	bottom: 0;
	background-color: var(--mantine-color-body);
	border-top: 1px solid var(--mantine-color-default-border);
	padding: var(--mantine-spacing-lg) var(--mantine-spacing-xl);
	z-index: 100;
}

.stickyButtonsTop {
	position: sticky;
	top: 0;
	background-color: var(--mantine-color-body);
	border-bottom: 1px solid var(--mantine-color-default-border);
	padding: var(--mantine-spacing-lg) var(--mantine-spacing-xl);
	z-index: 101;
	margin-top: calc(var(--mantine-spacing-lg) * -1);
	margin-left: calc(var(--mantine-spacing-xl) * -1);
	margin-right: calc(var(--mantine-spacing-xl) * -1);
}

.ticketHeaderContainer {
	background: linear-gradient(135deg, var(--mantine-color-body) 0%, var(--mantine-color-gray-light) 100%);
	border-radius: 8px;
	padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
	border: 2px solid var(--mantine-color-default-border);
	box-shadow: var(--mantine-shadow-sm);
	margin-bottom: var(--mantine-spacing-xs);
}

.ticketNumberBadge {
	background: linear-gradient(135deg, var(--mantine-color-biocells-green-6) 0%, var(--mantine-color-biocells-green-7) 100%);
	border: none;
	box-shadow: 0 2px 6px rgba(var(--mantine-color-biocells-green-6-rgb), 0.2);
	font-weight: 600;
	font-size: 14px;
	letter-spacing: 0.5px;
	text-transform: uppercase;
	padding: 8px 16px;
	min-height: 36px;

	&:hover {
		transform: translateY(-1px);
		transition: transform 0.2s ease;
	}
}

.ticketTitle {
	color: var(--mantine-color-text);
	font-weight: 600;
	font-size: 1.35rem;
	line-height: 1.4;
	margin: 0;
	text-shadow: none;
	letter-spacing: -0.02em;
}

.ticketHeaderContent {
	display: flex;
	align-items: flex-start;
	gap: var(--mantine-spacing-md);
	flex-wrap: wrap;

	@media (max-width: 768px) {
		flex-direction: column;
		gap: var(--mantine-spacing-sm);
	}
}

.ticketTitleWrapper {
	flex: 1;
	min-width: 0;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.groupDivider {
	background-color: rgba(var(--mantine-color-biocells-green-6-rgb), 0.06) !important;
	border: none;

	[data-mantine-color-scheme='dark'] & {
		background-color: rgba(var(--mantine-color-biocells-green-4-rgb), 0.1) !important;
	}

	td {
		padding-top: mantine.rem(4) !important;
		padding-bottom: mantine.rem(4) !important;

		&:first-child {
			padding-left: var(--mantine-spacing-md) !important;
			padding-right: 0 !important;
		}
	}
}

.groupTitle {
	color: var(--mantine-color-biocells-green-6);
	font-weight: 800;
	font-size: mantine.rem(11.5);
	text-transform: capitalize;
	letter-spacing: 0.01rem;
	display: flex;
	align-items: center;
	gap: mantine.rem(8);
	width: fit-content;
	padding: 0;
	background: transparent;
	border-radius: mantine.rem(2);

	[data-mantine-color-scheme='dark'] & {
		color: var(--mantine-color-biocells-green-4);
		background: transparent;
	}
}

.groupIndicator {
	display: none;
}

.stickyFooter {
	position: sticky;
	bottom: 0;
	background-color: var(--mantine-color-body);
	z-index: 20;
	border-top: 2px solid var(--mantine-color-default-border);

	tr {
		background-color: var(--mantine-color-body) !important;
	}

	td {
		border-top: 2px solid var(--mantine-color-default-border) !important;
	}
}
